import React from 'react';
import ProjectCard from '../components/ProjectCard';
import '../styles/Projects.css';

const Projects = () => {
  const projectData = [
    { title: 'Compiler for Measuring Testing Quality', subtitle:'ANTLR4, Java', img: 'files/project_compiler.png', 
      description: 'The project involves building a compiler using ANTLR4, a powerful parser generator, to support measuring the code coverage of a suite of input tests running on an input program. This project aims to provide a comprehensive tool for analyzing and visualizing code coverage.', 
      link: 'https://github.com/chinyee8/Compiler_for_Measuring_Testing_Quality/tree/main' },

    { title: 'Grocery List Android App', subtitle:'Android Studio, Java', img: 'files/project_grocery.png', 
      description: 'Development of a mobile application designed to assist visually impaired individuals in managing their grocery shopping. Created using Android Studio and Java, the app focuses on accessibility and user-friendliness. Additionally, the project includes a research study to evaluate the app\'s effectiveness and usability among visually impaired users.', 
      link: 'https://github.com/stevenhaddadcs/Grocery-List-App.git' },

    { title: 'E-commerce Website for Glasses', subtitle:'Ruby, HTML, JavaScript, CSS', img: '', 
      description: 'Developed a comprehensive e-commerce platform specializing in the sale of glasses, including prescription, sunglasses, and fashion eyewear. Built using Ruby on Rails, the website will provide a seamless shopping experience with a focus on user-friendly design and functionality.', 
      link: 'https://github.com/arigny/EECS4413-project' },

    // Add more projects here
  ];

  return (
    <div className="projects px-6 py-12">
      <h2 className="text-3xl font-bold mb-8">Projects</h2>
      <div className="project-list grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {projectData.map((project, index) => (
          <ProjectCard key={index} project={project} />
        ))}
      </div>
    </div>

  );
};

export default Projects;
